module.exports = "/img/videos/37.5b0f14.mp4";